import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ContentTypeIcon from "./ContentTypeIcon";
import Frame from "../../../assets/images/dummyFrame.svg"; // Add this import at the top
import FrameImage from "../../../assets/images/Frame.png"; // Add this import at the top
import { getDisplayNameFromCode } from "../utils/helperFunctions";
import { markFeatureEntry, ZYMED_SOURCE } from "../../../utils/zymedAnalytics";

const TpCarouselCard = (data: any) => {
  const navigate = useNavigate();
  const [hasError, setHasError] = useState(false);
  const location = useLocation();

  // Get current activeTab from URL if available
  const params = new URLSearchParams(location.search);
  const tab =
    document
      .querySelector(".bg-indigo-50")
      ?.textContent?.trim()
      .toLowerCase() || "latest";
  const currentTab =
    params.get("activeTab") ||
    (location.pathname === "/tatvapedia" &&
    !location.search &&
    tab !== "latest"
      ? tab
      : "latest");

  return (
    <div
      className="relative w-[17rem] h-[17rem] rounded-[1.5rem] overflow-hidden"
      onClick={() => {
        if (window.location.pathname === "/") {
          markFeatureEntry("/content", ZYMED_SOURCE.HOME_CARD_CLICK);
        }
        navigate("/content", {
          state: {
            id: data.docId,
            date: data.publishedDate,
            previousTab: currentTab,
            source: window.location.pathname + window.location.search,
          },
        });
      }}
    >
      {hasError ? (
        <div
          className="absolute w-full h-full flex items-center justify-center"
          style={{ backgroundImage: `url(${Frame})`, backgroundSize: "cover" }}
        >
          <img
            src={FrameImage}
            alt={data.contentTitle}
            className="w-3/4 h-3/4 object-contain" // Adjusted size and fit
          />
        </div>
      ) : (
        <img
          src={data.uploadThumbnailUrl}
          alt={data.contentTitle}
          className="absolute w-full h-full object-cover"
          onError={() => setHasError(true)}
        />
      )}
      <div className="flex">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/70 p-4 flex flex-col justify-end text-left">
          <span className="text-black text-sm bg-white px-3 py-1 rounded-full w-fit">
            {getDisplayNameFromCode(Array.isArray(data.consolidatedModule) ? data.consolidatedModule[0] : data.consolidatedModule || "")}
          </span>
          <h3 className="text-white text-xl font-semibold mt-2 line-clamp-2 w-[13rem]">
            {data.contentTitle}
          </h3>
          <div className="text-white/80 text-sm mt-2">
            {new Date(data.publishedDate).toLocaleDateString("en-GB", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })}
          </div>
        </div>
        <button className="absolute right-4 bottom-8 w-[3rem] h-[3rem] bg-white rounded-full flex items-center justify-center">
          <div className="rounded-full flex items-center justify-center">
            <ContentTypeIcon type={data.contentType} className="black" />
          </div>
        </button>
      </div>
    </div>
  );
};

export default TpCarouselCard;
